import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Box } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import ImageIcon from '@mui/icons-material/Image';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PercentIcon from '@mui/icons-material/Percent';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import React from 'react';
import useAuth from 'hooks/useAuth';
import LogoutIcon from '@mui/icons-material/Logout';
import LockIcon from '@mui/icons-material/Lock';
import QrCodeIcon from '@mui/icons-material/QrCode';

interface SidebarProps {
  open: boolean;
  onClose: () => void;
  drawerWidth: number;
  variant: 'permanent' | 'temporary';
  onOpenChangePasswordModal: () => void;
  onOpenScanQRCodeModal: () => void;
  onLogout: () => void;
}

const navigations = [
  {
    label: 'Quản lý nhân viên',
    icon: <PeopleIcon />,
    to: '/users',
    role: ['SUPER_ADMIN']
  },
  {
    label: 'Quản lý banner',
    icon: <ImageIcon />,
    to: '/banners',
    role: ['SUPER_ADMIN', 'ADMIN']
  },
  {
    label: 'Quản lý sản phẩm',
    icon: <ShoppingCartIcon />,
    to: '/products',
    role: ['SUPER_ADMIN', 'ADMIN']
  },
  {
    label: 'Quản lý khách hàng',
    icon: <PeopleIcon />,
    to: '/customers',
    role: ['SUPER_ADMIN', 'ADMIN']
  },
  {
    label: 'Quản lý voucher',
    icon: <PercentIcon />,
    to: '/vouchers',
    role: ['SUPER_ADMIN', 'ADMIN']
  },
  // {
  //   label: 'Quản lý tích điểm',
  //   icon: <UploadFileIcon />,
  //   to: '/points-management',
  //   role: ['SUPER_ADMIN', 'ADMIN']
  // },
];

const Sidebar: React.FC<SidebarProps> = ({ open, onClose, drawerWidth, variant, onOpenChangePasswordModal, onOpenScanQRCodeModal, onLogout }) => {
  const location = useLocation();
  const { user } = useAuth();
  const roleId = user?.role?.toUpperCase() || 'EXECUTIVE';

  const bottomNavigations = [
    {
      label: 'Quét QR Code',
      icon: <QrCodeIcon />,
      onClick: onOpenScanQRCodeModal,
    },
    {
      label: 'Đổi mật khẩu',
      icon: <LockIcon />,
      onClick: onOpenChangePasswordModal,
    },
    {
      label: 'Đăng xuất',
      icon: <LogoutIcon />,
      onClick: onLogout,
    },
  ];

  const filteredNavigations = navigations.filter((nav) => {
    if (nav.role.includes(roleId)) {
      return true;
    }
    return false;
  });

  return (
    <Drawer
      variant={variant}
      open={open}
      onClose={onClose}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
      }}
    >
      <Toolbar />
      <Box sx={{ overflow: 'auto' }}>
        <List>
          {filteredNavigations.map((nav) => (
            <ListItem disablePadding key={nav.to}>
              <ListItemButton
                component={RouterLink}
                to={nav.to}
                onClick={onClose}
                selected={location.pathname.startsWith(nav.to)}
              >
                <ListItemIcon>{nav.icon}</ListItemIcon>
                <ListItemText primary={nav.label} />
              </ListItemButton>
            </ListItem>
          ))}
          {bottomNavigations.map((nav) => (
            <ListItem disablePadding key={nav.label}>
              <ListItemButton
                onClick={nav.onClick}
                selected={false}
              >
                <ListItemIcon>{nav.icon}</ListItemIcon>
                <ListItemText primary={nav.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar; 